module.exports = __webpack_public_path__ + "media/הן.c91f3d73.mp3";